import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext.js';

const RoleRoute = ({ children, requiredRole = 'admin' }) => {
  const { user, loading, role } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-400">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/portal/login" replace />;
  }

  if (role !== requiredRole) {
    return <Navigate to="/portal/routes" replace />;
  }

  return children;
};

export default RoleRoute;
